import * as React from 'react';

// @ts-ignore
import AdminNoticeBanner from 'admin/components/AdminNoticeBanner';
import { ConstructedLinks } from 'constants/LinkConstants';
import EventTracking from 'lib/EventTracking';
// @ts-ignore
import FreeClassLimitsLearnMoreDialog from 'groups/components/FreeClassLimitsLearnMoreDialog';
import Link from 'components/Link';
import ModalTrigger from 'components/ModalTrigger';
import Row from 'components/Row';
import Text from 'components/Text';

export const eventKeyPrefix = 'free_product_limits.invite_modal.limit_reached_banner';

type Props = {
  numberOfPeopleLimit: number;
  groupCode: string;
};

class FreeClassMembershipLimitNotice extends React.Component<Props> {
  componentDidMount() {
    this.trackEvent('view');
  }

  trackEvent(event: string) {
    EventTracking.trackKey(`${eventKeyPrefix}.${event}`);
  }

  render() {
    return (
      <Row>
        <AdminNoticeBanner icon="megaphone-off" color="lava">
          <Text size="xsmall" align="left" lineHeight="large">
            {`Your free Remind account includes announcements for classes with up to ${
              this.props.numberOfPeopleLimit
            } people. To enable announcements for larger classes, your organization can purchase a Remind plan. `}
            <Link
              onClick={() => this.trackEvent('upgrade_organization.click')}
              weight="semibold"
              href={ConstructedLinks.PLANS_GRID_FROM_FREE_PRODUCT_LIMITS}
              target="_blank"
              data-test="upgrade-org-link">
              Upgrade your organization
            </Link>
            {' or '}
            <ModalTrigger
              data-test="learn-more-link"
              onClick={() => this.trackEvent('learn_more.click')}
              modal={
                <FreeClassLimitsLearnMoreDialog
                  onRequestHide={() => {}}
                  uiContext="class_membership_limit_notice"
                  peopleListUrl={`/classes/${this.props.groupCode}/people`}
                />
              }>
              <Link weight="semibold">learn more</Link>
            </ModalTrigger>
          </Text>
        </AdminNoticeBanner>
      </Row>
    );
  }
}

export default FreeClassMembershipLimitNotice;
